import script from "./SavedView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavedView.vue?vue&type=script&setup=true&lang=ts"

import "./SavedView.vue?vue&type=style&index=0&id=63475e9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63475e9a"]])

export default __exports__